<template>
  <div>
    <!--商品信息 -->
    <div class="detail">
      <div class="productInformation-box">

        <!-- 商品名称-->
        <div class="productName">
          <!-- 商品名称（中文） -->
          <div class="item">
            <div class="name">
              {{ $t('message.productNameChinese') }}
            </div>
            <el-input type="textarea" v-model="detail.goods_title_cn"></el-input>
          </div>
          <!-- 商品名称（日文） -->
          <div class="item">
            <div class="name">
              {{ $t('message.productNameJapanese') }}
            </div>
            <el-input type="textarea" v-model="detail.goods_title"></el-input>
          </div>
        </div>
        <!-- 商品管理备注 -->
        <div class="productManagementRemarks">
          <div class="item">
            <div class="name">
              {{ $t('message.productManagementRemarks') }}(日文)
              <!-- 下单自动跟随 -->
              <el-checkbox v-model="detail.remark_auto_order" class="fr" style="margin: 10px 24px 0 0"> {{
                $t('message.automaticallyFollowOrders') }}</el-checkbox>
            </div>
            <div class="content">
              <el-input type="textarea" v-model="detail.remark"></el-input>
            </div>
          </div>
          <!--  业务管理备注-->
          <div class="item">
            <div class="name">
              {{ $t('message.businessManagementRemarks') }}(中文)
              <!-- 下单自动跟随 -->
              <el-checkbox v-model="detail.y_remark_auto_order" class="fr" style="margin: 10px 0px 0 0"> {{
                $t('message.automaticallyFollowOrders') }}</el-checkbox>
            </div>
            <div class="content">
              <el-input type="textarea" v-model="detail.y_remark"></el-input>
            </div>
          </div>
        </div>
        <!--尺寸  单重-->
        <div class="productSize">
          <!-- 商品尺寸 -->
          <div class="name">
            {{ $t('message.productSize') }}(cm)
          </div>
          <div class="size">
            <el-input v-model="detail.length" type="number"></el-input>*<el-input v-model="detail.width"
              type="number"></el-input> *
            <el-input v-model="detail.height" type="number"></el-input>
          </div>
          <!--  商品单重-->
          <div class="name">
            {{ $t('message.singleWeightOfProduct') }}(g)
          </div>
          <p> <el-input v-model="detail.weight" type="number"></el-input></p>
        </div>
      </div>
    </div>
    <!-- 基础设置 -->
    <!-- 商品属性 -->
    <div class="basicSettings-item">
      <div class="name">{{ $t('message.commodityAttribute') }}</div>
      <div class="row" v-for="(item, index) in typeList" :key="index">
        <div class="label">{{ item.name }}</div>
        <div class="value">
          <!-- 支持   -->
          <el-radio v-model="item.value" label="1">{{ $t('message.support') }}</el-radio>
          <!-- 不支持 -->
          <el-radio v-model="item.value" label="2"> {{ $t('message.noSupport')
          }}</el-radio>
        </div>
      </div>
    </div>
    <!-- 违禁品类别 -->
    <div class="basicSettings-item">
      <div class="name">{{ $t('message.categoryOfProhibitedItems') }}</div>

      <el-checkbox :label="item.value" v-for="(item, index) in forbidTypeList" :key="index"
        style="margin: 0 30px 24px 0;" v-model="item.checked"></el-checkbox>

    </div>
    <!-- 捆包图 -->
    <div class="basicSettings-item">
      <div class="name">{{ $t('message.packingDiagram') }}</div>
      <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card"
        :on-preview="handlePictureCardPreview" :on-remove="handleRemove" multiple drag :http-request="httpup"
        :file-list="detail.client_product_image_pack" :before-upload="befoUpload">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {

  data() {
    return {
      checked: false,
      detail: {
        client_product_image_pack: [],
        "goods_title": "",
        "goods_title_cn": "",
        "forbid_type": [],
        "length": "",
        "width": "",
        "height": "",
        "weight": '',
        "y_remark": "",
        "y_remark_auto_order": true,

        "remark": "",
        "remark_auto_order": true,
        pack_image: [],
      },
      forbidTypeList: [],
      typeList: [
        {
          name: '现货',
          value: '2',
        },
        {
          name: 'OEM',
          value: '2',
        },
        {
          name: 'ODM',
          value: '2',
        }
      ],
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  created() {
    this.$api.siteConfiguration.forbidTypes().then(res => {
      res.data.forEach(item => {
        item.checked = false
      })
      this.forbidTypeList = res.data
    })
  },
  methods: {
    // 保存数据
    setData(sys_code_set) {
      let datas = {
        sys_code_set,
        "goods_title": this.detail.goods_title,
        "goods_title_cn": this.detail.goods_title_cn,
        "forbid_type": [],
        "length": this.detail.length,
        "width": this.detail.width,
        "height": this.detail.height,
        "weight": this.detail.weight,
        "y_remark": this.detail.y_remark,
        "y_remark_auto_order": this.detail.y_remark_auto_order ? 1 : 0,

        "remark": this.detail.remark,
        "remark_auto_order": this.detail.remark_auto_order ? 1 : 0,
        pack_image: [],
        type_name: [],
      }
      this.detail.client_product_image_pack.forEach(item => {
        datas.pack_image.push(item.url)
      })
      this.forbidTypeList.forEach(item => {
        if (item.checked) {
          datas.forbid_type.push({
            key: item.key,
            value: item.value
          })
        }
      })
      this.typeList.forEach(item => {
        if (item.value == 1) {
          datas.type_name.push(item.name)
        }
      })
      this.$api.productManagementApi.batchUpdateBase(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    handleRemove(file, fileList) {
      this.detail.client_product_image_pack = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    befoUpload(file) {
      const isPic =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      if (!isPic) {
        if (file.name.indexOf('HEIC') == -1) {
          this.$message.error("请上传图片");
          return false
        }
      }
      return isPic;
    },
    // 上传
    async httpup(file) {
      const isPic =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.file.type) != -1;
      if (!isPic) {
        return false
      }
      if (this.detail.client_product_image_pack.length > 6) return this.$message.error('图片最多只能上传6张')
      let data = await this.createClient(file)
      this.detail.client_product_image_pack.push({ url: data.data })
    },

  }
}
</script>
<style lang='scss' scoped>
.basicSettings-item {
  padding: 24px;
  border: 1px solid #dedede;
  border-radius: 6px;
  margin-bottom: 24px;

  .name {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-bottom: 24px;
  }

  .row {
    display: flex;
    line-height: 40px;
    margin-bottom: 24px;

    .label {
      width: 100px;
    }

    .value {
      flex: 1;
    }
  }

  /deep/.el-upload-dragger {
    width: auto;
    height: 118px;
    border: none;
  }
}

.detail {

  padding: 24px;

  border-radius: 6px;

  .content {
    border-right: 1px solid #DFDFDF;
    padding-right: 70px;
    display: flex;
  }

  .name {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-bottom: 18px;
  }

  /deep/.el-textarea__inner {
    width: 260px;
    height: 160px;
    resize: none;
  }


  .img {
    position: relative;

    &:hover {
      .redact {
        display: block;
      }
    }

    .redact {
      position: absolute;
      top: 0;
      right: 20px;
      display: none;
    }
  }

  .productInformation-box {
    display: flex;
    margin-bottom: 24px;

    .attribute {
      width: 215px;

      .tag {
        width: 190px;
        height: 36px;
        background: #FFEEEE;
        border-radius: 4px;
        position: relative;
        color: #B4272B;
        padding-left: 10px;
        line-height: 36px;
        margin-bottom: 24px;

        .el-icon-caret-right {
          font-size: 57px;
          position: absolute;
          top: -10px;
          right: -35px;
          color: #FFEEEE;

        }
      }
    }

  }

  .productName {
    display: flex;


    .item {
      margin-right: 70px;

      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }

  .productManagementRemarks {
    display: flex;

    .item {
      &:nth-child(1) {
        .content {
          margin-left: 70px;
          padding-left: 70px;
          border-left: 1px solid #DFDFDF;
          border-right: 0;
        }
      }

      &:nth-last-child(1) {
        .content {
          border-left: 0px solid #DFDFDF;
        }

        .name {
          margin-left: 0px;
        }
      }
    }

    .name {
      margin-left: 120px;
    }

  }

  .productSize {
    margin-left: 45px;

    .size {
      display: flex;
      line-height: 40px;
      margin-bottom: 45px;

      /deep/.el-input__inner {
        padding: 0;
        text-align: center;
      }
    }
  }
}
</style>